<template>
    <form v-if="editItem" autocomplete="off" class="">
        <h4>You have been selected for this payment. </h4>
        <div class="pt-4">
            <p class="mb-1">
                Please confirm your interest by either accepting or rejecting this Payment. Acceptance time expires at:
            </p>
            <div class="mb-4">
                <count-down-timer size="sm" body-class="mt-3" :deadline="editItem.acceptance_deadline" />
            </div>
            <div v-if="!acceptanceTimeElapsed">
                <div class="form-check mb-4">
                    <input v-model="data.data_collection" class="form-check-input" type="checkbox" id="flexCheckDataCollection">
                    <label class="form-check-label" for="flexCheckDataCollection">
                        By checking this box, I agree that the information provide in my acccount in this portal is true and correct.
                    </label>
                </div>
                <div class="form-check mb-4">
                    <input v-model="data.refund_condition" class="form-check-input" type="checkbox" id="flexCheckRefundCondition">
                    <label class="form-check-label" for="flexCheckRefundCondition">
                        By checking this box, I agree that I am not currently under any paid employment, and if found otherwise, I am aware that I shall be sanctioned by Government of Akwa Ibom State and all monies paid shall be refunded.
                    </label>
                </div>
                <div class="form-check">
                    <input v-model="data.beneficial_condition" class="form-check-input" type="checkbox" id="flexCheckBeneficialCondition">
                    <label class="form-check-label" for="flexCheckBeneficialCondition">
                        By checking this box, I agree  that having benefitted from this grant, I can not benefit from any Government grants or similar Schemes within one year starting from the effective date of receipt of this grant. Nevertheless, I am aware that I am at liberty to apply and compete for other open employments on this portal.
                    </label>
                </div>                            
                <div class="d-grid d-sm-flex pt-4 gap-4">
                    <button @click="acceptPayment()" class="btn btn-primary w-100 mb-2 mb-sm-0"  type="button" >Accept Payment</button>
                    <button @click="rejectPayment()" class="btn btn-warning w-100"  type="button" >Reject Payment</button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { required, helpers, requiredIf } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import CountDownTimer from '@/components/widgets/CountDownTimer.vue';

const mustBeTrue = (message) => helpers.withMessage(message, (value) => value === true);

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components:{
        CountDownTimer
    },
    props:{
        editItem:{
            type: Object,
            default: null
        },
    },
    data(){
        return{
            data: {
                data_collection: false,
                refund_condition: false,
                beneficial_condition: false
            },
        }
    },
    computed:{
        acceptanceTimeElapsed(){
            var now = new Date().getTime();
            var deadlineTime = new Date(this.editItem.acceptance_deadline).getTime();
            var distance = deadlineTime - now;
            return distance < 1;
        }
    },
    validations() {
        return {        
            data:{
                data_collection: { mustBeTrue: mustBeTrue("You must agree that the information provided is true and correct.") },
                refund_condition: { mustBeTrue: mustBeTrue("You must agree to the refund condition if found under paid employment.") },
                beneficial_condition: { mustBeTrue: mustBeTrue("You must accept the condition regarding grant eligibility for one year.") },
            },
        }
    },
    methods:{
        async acceptPayment(){
            const result = await this.v$.$validate();
            if (!result) {
                this.alertError(this.v$.$errors[0].$message);
                return;
            }
            
            this.confirmAction({
                icon: 'success',
                html: "By accepting, be well assured that you will not accept any other grant/payment in the next one year. Are you ready to proceed?",
            }).then((result) => {
                if (result.value) {
                this.$store.dispatch("changeLoaderValue",true)
                this.$http.post(`/payment-recipients/${this.editItem.id}/accept`)
                .then(response => {
                    this.$store.dispatch("changeLoaderValue", false)
                    if(response.data.success){
                        this.$emit('updateItem', response.data.data)
                    }
                })
                }
            });
        },
        rejectPayment(){
            this.confirmAction({
                icon: 'warning',
                title: "You're about to decline this payment.",
                html: "By rejecting, you will no longer be considered for this payment. Are you sure you want to proceed?",
            }).then((result) => {
                if (result.value) {
                this.$store.dispatch("changeLoaderValue",true)
                this.$http.post(`/payment-recipients/${this.editItem.id}/reject`)
                .then(response => {
                    this.$store.dispatch("changeLoaderValue", false)
                    if(response.data.success){
                        this.$emit('updateItem', response.data.data)
                    }
                })
                }
            });
        },
        resetForm(){
            this.v$.$reset()
            this.$emit("closeMe")
        },
    },
}
</script>